import React from 'react'
import '../../../../App.scss';
import Grid from "@material-ui/core/Grid";
import ButtonBackground from '../../../../assets/images/empty_wood_btn.png'
import Badge from '../../../pageComponents/Home/GiftHall/Badge'
import Clock from '../../../../assets/images/clocks.png'
import CircleOrange from "../../../../assets/images/circle_orange.png";
class horizontalDivider extends React.Component{
    constructor() {
        super()
        this.state={
        }
    }
    render() {
        const{data}=this.props
        return (
            <Grid className='divider-horizontal-first' container alignItems={"center"} justify={"center"}>
                <Grid className='divider-horizontal-second' container alignItems={"center"} justify={"center"}>
                    <Grid className='divider-horizontal-third' container alignItems={"center"} justify={"space-between"}>
                        <Grid container sm={2} xs={2} justify={"center"} alignItems={"center"}>
                            <Grid item style={{position:'absolute',width:'30%'}}>
                                <img src={CircleOrange} className='gift-hall-divider-banner-score-image' alt=""/>
                            </Grid>
                        </Grid>
                        <Grid container style={{position:'relative'}} sm={2} xs={2} justify={"center"} alignItems={"center"}>
                            <Grid container style={{position:'absolute',width:'200%'}} >
                                <Badge data={data}/>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

        )
    }
}
export default horizontalDivider